export default __webpack_public_path__ + "static/media/83b040922d3bf857a139b47eb3b9304a.svg";